import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/en/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/blog/${params.slug}`, loaderData, params.slug === "eudravigilance-signal-management-approaches" ? {
      title: "EudraVigilance Signal Management: Choosing Your Approach | QbD Group",
      description: "Explore three ways to integrate EudraVigilance data into signal management, from validation and evaluation to risk-based detection and monitoring.",
    } : params.slug === "eu-variations-grouping-worksharing-guide" ? {
      title: "EU Variations: A Practical Guide to Grouping and Worksharing | QbD Group",
      description: "Learn how to use grouping and worksharing under the 2025 EU Variations Guidelines to coordinate submissions and improve lifecycle planning.",
    } : params.slug === "capa-backlog-management-inspection-readiness" ? {
      title: "CAPA Backlog Management: From Triage to Inspection Readiness | QbD Group",
      description: "Learn how to manage CAPA backlogs through risk-based triage, root cause analysis and effectiveness checks to strengthen GMP inspection readiness.",
    } : {}),
  component: BlogPost,
});

